<template>
  <div
    class="coremodal-header tw-flex tw-justify-between tw-items-center"
    :data-test="dataTest">
    <div
      :class="[
        'tw-flex tw-grow',
        'tw-items-center',
      ]"
      :data-test="`${dataTest}-title`">
      <SVGIcon
        v-if="iconName"
        class="coremodal-header__icon tw-mr-2"
        :iconName="iconName"
        data-test="icon-title"
        colorClass="tw-fill-core-primary-50" />
      <span
        v-if="title"
        class="modal-title tw-text-core-primary-10 headlines--headline-06"
        data-test="modal-title">
        {{ title }}
      </span>
    </div>
    <div
      class="cursor-pointer"
      @click.stop="emit('close')">
      <SVGIcon
        iconName="Close"
        data-test="icon-close"
        colorClass="tw-fill-core-neutral-cold-20" />
    </div>
  </div>
</template>

<script setup lang='ts'>
import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'

defineProps({
  iconName: {
    type: String,
    required: false,
  },
  title: {
    type: String,
    required: false,
  },
  dataTest: {
    type: String,
    default: '',
  },
})

type Emits = (e: 'close') => void
const emit = defineEmits<Emits>()

</script>
